export const translations = {
    en: {
      menuTitle: "Restaurant Menu",
      searchPlaceholder: "Search menu items...",
      searchButton: "Search",
      priceLabel: "Price",
      addToCart: "Add to Cart",
      closeButton: "Close",
      description: "Description",
      cartTitle: "Shopping Cart",
      subtotal: "Subtotal",
      tax: "Tax (5%)",
      total: "Total",
      proceedToCheckout: "Proceed to Checkout",
      thankYou: "Thank You!",
      thankYouMessage: "Your payment was successful!",
      enjoyMeal: "Enjoy your meal!",
      paymentSuccess: "Payment Success",
      name: "Name",
      enterName: "Please enter your name!",
      cardNumber: "Card Number",
      cardNumberRequired: "Please enter your card number!",
      cardNumberLength: "Card number must be 16 digits!",
      expiryDate: "Expiry Date",
      expiryRequired: "Please enter expiry date!",
      cvv: "CVV",
      cvvRequired: "Please enter CVV!",
      cvvLength: "CVV must be 3 digits!",
      payNow: "Pay Now",
      noOrderHistory: "You have no previous orders.",
      quantity: "Quantity",
      item: "Item",
      actions: "Actions",
      Menu: "Menu",
      Cart: "Cart",
      orderHistory: "Order History",
      loading: "Loading...",
      errorLoading: "Failed to load data",
      noDescription: "No description available.",
      paymentDetails: "Payment Details",
    },
    lv: {
      menuTitle: "Restorāna ēdienkarte",
      searchPlaceholder: "Meklēt ēdienus...",
      searchButton: "Meklēt",
      priceLabel: "Cena",
      addToCart: "Pievienot grozam",
      closeButton: "Aizvērt",
      description: "Apraksts",
      cartTitle: "Iepirkumu grozs",
      subtotal: "Starpsumma",
      tax: "PVN (5%)",
      total: "Kopā",
      proceedToCheckout: "Pāriet pie apmaksas",
      thankYou: "Paldies!",
      thankYouMessage: "Jūsu maksājums bija veiksmīgs!",
      enjoyMeal: "Labu apetīti!",
      paymentSuccess: "Maksājuma detaļas",
      name: "Vārds",
      enterName: "Lūdzu, ievadiet savu vārdu!",
      cardNumber: "Kartes numurs",
      cardNumberRequired: "Lūdzu, ievadiet kartes numuru!",
      cardNumberLength: "Kartes numuram jābūt 16 cipariem!",
      expiryDate: "Derīguma termiņš",
      expiryRequired: "Lūdzu, ievadiet derīguma termiņu!",
      cvv: "CVV",
      cvvRequired: "Lūdzu, ievadiet CVV!",
      cvvLength: "CVV jābūt 3 cipariem!",
      payNow: "Maksāt",
      noOrderHistory: "Jums nav iepriekšējo pasūtījumu.",
      quantity: "Daudzums",
      item: "Vienums",
      actions: "Darbības",
      Menu: "Izvēlne",
      Cart: "Grozs",
      orderHistory: "Pasūtījumu Vēsture",
      loading: "Ielādē...",
      errorLoading: "Neizdevās ielādēt datus",
      noDescription: "Nav apraksta.",
      paymentDetails: "Maksājuma detaļas",
    },
  };
  
  export const translate = (key, language = "en") => {
    return translations[language][key] || key;
  };
  